define('plugin/invoice/collection/InvoiceLineCollection',['require','lib/collection/BaseCollection','plugin/invoice/model/InvoiceLineModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoiceLineModel = require('plugin/invoice/model/InvoiceLineModel');

    /**
     * Invoice line collection
     *
     * @class InvoiceLineCollection
     */
    return BaseCollection.extend({

        model: InvoiceLineModel

    });

});
